import { categoryActions } from '../../store/modules/category';
import { videoActions } from '../../store/modules/video';

import { DispatchGetInitialProps } from './dispatchCurrentTemplateNew';
import dispatchPageContent from './dispatchPageContent';
import { getAspects } from './dispatchPageContent/helpers';

export default ({ res, query, dispatch }: DispatchGetInitialProps) => {
  dispatch(videoActions.getVideoFormats());
  dispatch(categoryActions.getCategoryList());

  const aspects = getAspects(query.aspects);
  const newQuery = { ...query, aspects } as DispatchGetInitialProps['query'];

  dispatchPageContent({ res, dispatch, query: newQuery });
};
